import { render, staticRenderFns } from "./SelectOrg.vue?vue&type=template&id=1bd965f4&"
import script from "./SelectOrg.vue?vue&type=script&lang=js&"
export * from "./SelectOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports